export default "assets/images/icons/download-852b5c58.svg";